import { useMutation } from '@apollo/client';
import { Button, Col, Modal, Row } from 'antd';
import { upperCase } from 'lodash';

import { useParams } from 'react-router-dom';
import { GENERATE_BILL } from './graphql/Mutations';
import { FETCH_ORDER } from './graphql/Queries';

const GenerateBillModal = ({ isModalOpen, setIsModalOpen }) => {
  const { id } = useParams();
  const [generateOrderBill, { loading }] = useMutation(GENERATE_BILL, {
    refetchQueries: [
      {
        query: FETCH_ORDER,
        variables: {
          where: { id },
        },
        fetchPolicy: 'network-only',
      },
    ],
    onError() {},
  });

  return (
    <div>
      <Modal
        centered
        closable={false}
        title={<h3 className="m-0 mb-10">{upperCase(`Generate invoice`)}</h3>}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        open={isModalOpen}
        width={576}
        maskClosable={false}
      >
        <p className="mb-16 mt-10">
          Are you sure you want to generate Invoice?
          <br />
          <b>Please note: You will not be able to modify price.</b>
        </p>
        <Row gutter={10}>
          <Col span={12}>
            <Button
              disabled={loading}
              onClick={() => {
                setIsModalOpen(false);
              }}
              className="full-width font-600 submit-btn"
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              className="full-width font-600 submit-btn"
              loading={loading}
              onClick={() => {
                generateOrderBill({
                  variables: {
                    where: {
                      id,
                    },
                  },
                }).then((res) => {
                  if (res?.data?.generateOrderBill) setIsModalOpen(false);
                });
              }}
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default GenerateBillModal;
